import { type FC } from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Button } from 'components/Button/Button'
import { IconButton } from 'components/IconButton/IconButton'
import { useModalContext } from 'context/modalContext'
import { AllIcons } from 'helpers/allIcons'
import { type User } from 'types/types'

import AvatarHolder from '../AvatarHolder/AvatarHolder'
import FriendRequestMessageModal from '../Modal/FriendRequest/FriendRequestMessage/FriendRequestMessageModal'

import './_userCard.scss'

// TODO separate in two components
const UserCardFriend: FC<{
    user: User
    type: string
    friendReqAccept?: () => void
    friendReqDeny?: () => void
    lastItemRef?: any
}> = ({ user, type, friendReqAccept, friendReqDeny, lastItemRef }) => {
    const modalData = useModalContext()
    const { t } = useTranslation()

    const showMessage = (
        user: User,
        friendReqAccept?: () => void,
        friendReqDeny?: () => void
    ) => {
        modalData.addModal(
            t('friendRequest'),
            <FriendRequestMessageModal
                user={user}
                friendReqAccept={friendReqAccept}
                friendReqDeny={friendReqDeny}
            />
        )
    }

    if (type === 'request') {
        return (
            <div
                className='userCard userCard--friend userCard--friendReq'
                ref={lastItemRef}
            >
                <div className='userCard__avatar'>
                    <AvatarHolder
                        size='60'
                        img={user.croppedAvatar.url || user.avatar.url}
                        isOnline={true}
                        userId={user.id}
                    />
                </div>
                <div className='userCard__info'>
                    <p className='userCard__info__name'>{user.name}</p>
                    <p className='userCard__info__username'>@{user.username}</p>
                    {user.fans ? (
                        <p className='userCard__info__fans'>
                            <span>{user.fans}</span> {t('Fans')}
                        </p>
                    ) : (
                        ''
                    )}
                    {/* {user.requested_at ? (
                        <p className='userCard__info__time'>
                            {user.requested_at}
                        </p>
                    ) : (
                        ''
                    )} */}
                    {user.message && (
                        <p
                            className='userCard__info__message'
                            onClick={() => {
                                showMessage(
                                    user,
                                    friendReqAccept,
                                    friendReqDeny
                                )
                            }}
                        >
                            {t('viewMessage')}
                        </p>
                    )}
                </div>
                <div className='userCard__actions'>
                    <IconButton
                        type='white'
                        clickFn={friendReqDeny}
                        icon={AllIcons.close}
                        customClass='userCard__actions__deny'
                    />
                    <div>
                        {user.requested_at ? (
                            <p className='userCard__info__time'>
                                {user.requested_at}
                            </p>
                        ) : (
                            ''
                        )}
                        <Button
                            text={t('accept')}
                            color='blue'
                            font='mont-14-normal'
                            width='fit'
                            height='4'
                            padding='1'
                            clickFn={friendReqAccept}
                        />
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className='userCard userCard--friend' ref={lastItemRef}>
                <Link to={`/${user.username}`} className='userCard__avatar'>
                    <AvatarHolder
                        size='60'
                        img={user.croppedAvatar?.url || user.avatar.url}
                        isOnline={type === 'request' ? true : undefined}
                        userId={user.id}
                    />
                </Link>
                <div className='userCard__info'>
                    <p className='userCard__info__name'>{user.name}</p>
                    <p className='userCard__info__username'>{user.username}</p>
                    <p className='userCard__info__fans'>
                        <span>{user.fans}</span> {t('Fans')}
                    </p>
                </div>
                <div className='userCard__actions'>
                <div className='userCard__actions'>
                    <Link
                        to={`/chat/${user.id}`}
                        state={{
                            activePage: !user.conversation ? 'newmessage' : '',
                            otherUserData: {
                                ...user,
                                display_name: user.display_name ?? user.name ?? '',
                                username: user.username ?? '',
                                avatar: user.avatar,
                                croppedAvatar: user.croppedAvatar,
                                isSubscribed: true
                            },
                            ...(user.conversation?.id
                                ? { conversationId: user.conversation.id }
                                : user.conversation_id
                                ? { conversationId: user.conversation_id }
                                : {})
                        }}
                    >
                        <IconButton
                            type='white'
                            icon={AllIcons.chat_bubble_blue}
                        />
                    </Link>
                </div>
                </div>
            </div>
        )
    }
}

export default UserCardFriend
